import { Select } from '../select/select.tsx';
import { SettingsRow, SettingsValue } from '../settings/settings-row.tsx';
import type { MeetingTemplateEditorLabels } from './meeting-template-editor-labels.ts';
import type {
  MeetingTemplateCohortOption,
  MeetingTemplateTrackOption,
} from './meeting-template-types.ts';
import { templateAudienceOptions } from './template-audience-options.ts';

interface TemplateAudienceRowProps {
  value: string;
  tracks: MeetingTemplateTrackOption[];
  cohorts: MeetingTemplateCohortOption[];
  /** Says why there is no audience to pick instead of offering the field. */
  wholeOrganisationOnly: boolean;
  labels: MeetingTemplateEditorLabels;
  onChange: (value: string) => void;
}

/** Who the template is for: a track, a cohort, or the whole organisation. */
export function TemplateAudienceRow({
  value,
  tracks,
  cohorts,
  wholeOrganisationOnly,
  labels,
  onChange,
}: TemplateAudienceRowProps) {
  if (wholeOrganisationOnly) {
    return (
      <SettingsRow label={labels.audienceLabel} description={labels.audienceDefaultNote}>
        <SettingsValue>{labels.audienceNone}</SettingsValue>
      </SettingsRow>
    );
  }

  return (
    <SettingsRow label={labels.audienceLabel} description={labels.audienceHint}>
      <Select
        aria-label={labels.audienceLabel}
        value={value}
        options={templateAudienceOptions(tracks, cohorts, labels)}
        onChange={(event) => onChange(event.target.value)}
      />
    </SettingsRow>
  );
}
